// @flow
import { Record, List } from "immutable"

import MultiPlace from "./MultiPlace"
import { createAnytime } from "./SearchDate/utils"
import SearchPlace from "./SearchPlace"
import type { SearchDate } from "./SearchDate/SearchDate"

const MulticityFormDataRecord = Record({
  outboundDate: createAnytime(true),
  origin: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
  destination: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
  joinDestinationWithNext: false,
})

export default class MulticityFormData extends MulticityFormDataRecord {
  outboundDate: SearchDate

  origin: MultiPlace

  destination: MultiPlace

  joinDestinationWithNext: boolean

  crossesDateLine(): boolean {
    const originGeo = this.origin.getGeo()
    const destinationGeo = this.destination.getGeo()
    return Boolean(
      originGeo && destinationGeo && Math.abs(originGeo.lng - destinationGeo.lng) > 180,
    )
  }

  // TODO: flowtype plain
  static fromPlainJS(plain: any): MulticityFormData {
    return new MulticityFormData({
      ...plain,
      origin: MultiPlace.fromPlainJS(plain.origin),
      destination: MultiPlace.fromPlainJS(plain.destination),
      outboundDate: plain.outboundDate,
    })
  }
}
